import fetch from '@/api/fetch'

/**
 * 获取热门城市
 */
export function getPopularCity(params) {
  return fetch({
    url: '/v1/address/popularCity',
    unLogin: true,
    params
  })
}

/**
 * 获取去地址选择器选择数据
 */
export function getaAddressData(params) {
  return fetch({
    url: '/v1/address/getAddresses',
    unLogin: true,
    params
  })
}

/**
 * @description 保存地址
 * @date 2019-03-20
 * @export
 * @param {*} data
 * @returns
 */
export function saveAddressReq(data) {
  return fetch({
    url: '/my/address/newOrEdit',
    setCsrfToken: true,
    method: 'POST',
    data
  })
}

/**
 * 删除地址
 */
export function deleteAddressByIdReq(id) {
  return fetch({
    url: '/my/address/del',
    setCsrfToken: true,
    params: {
      id
    }
  })
}
